import { create } from "zustand";

type RxQuestionnaireStore = {
  isOpen: boolean;
  conversationId: string | null;
  open: (conversationId: string) => void;
  close: () => void;
  complete: () => void;
};

export const useRxQuestionnaireStore = create<RxQuestionnaireStore>((set) => ({
  isOpen: false,
  conversationId: null,
  open: (conversationId: string) => set({ isOpen: true, conversationId }),
  close: () => set({ isOpen: false, conversationId: null }),
  complete: () => set({ isOpen: false, conversationId: null }),
}));
